/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {AfterContentChecked, ChangeDetectorRef, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {WillyWonka} from './willy-wonka';
/**
 * @abstract
 */
export abstract class OompaLoompa implements AfterContentChecked, OnDestroy {
/**
 * @param {?} cdr
 * @param {?} willyWonka
 */
constructor(cdr: ChangeDetectorRef, willyWonka: WillyWonka) {
        this.subscription = willyWonka.chocolate.subscribe(() => {
            if (this.latestFlavor !== this.flavor) {
                cdr.detectChanges();
            }
        });
    }
private subscription: Subscription;
private latestFlavor: any;
/**
 * @abstract
 * @return {?}
 */
flavor() {}
/**
 * @return {?}
 */
ngAfterContentChecked() {
        this.latestFlavor = this.flavor;
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}

function OompaLoompa_tsickle_Closure_declarations() {
/** @type {?} */
OompaLoompa.prototype.subscription;
/** @type {?} */
OompaLoompa.prototype.latestFlavor;
}

